export const debounce = (callbackFunc, delay = 400) => {
  let timeoutId
  return (...args) => {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      callbackFunc(...args)
    }, delay)
  }
}
